import dynamic from "next/dynamic";
import {
  Paragraph,
  Columns,
  Column,
  Code,
  ListItem,
  Html,
  Image,
  Buttons,
  Button,
  Video,
  Separator,
  Youtube,
  Table,
} from "./clientCoreBlocks";
import { BlockRenderer } from ".";
import { Suspense } from "react";
import Heading from "@litonarefin/components/CoreBlocks/Heading";

//core blocks
const Cover = dynamic(() => import("@litonarefin/components/CoreBlocks/Cover"));
const List = dynamic(() => import("@litonarefin/components/CoreBlocks/List"));
const Spacer = dynamic(() => import("@litonarefin/components/CoreBlocks/Spacer"));
const Embed = dynamic(() => import("@litonarefin/components/CoreBlocks/Embed"));

export const coreBlocks = {
  ["core/columns"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Columns attributes={block?.attributes} colNumbers={block.innerBlocks?.length}>
        <BlockRenderer blocks={block.innerBlocks} />
      </Columns>
    </Suspense>
  ),
  ["core/column"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Column attributes={block?.attributes}>
        <BlockRenderer blocks={block.innerBlocks} />
      </Column>
    </Suspense>
  ),
  ["core/video"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Video attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/embed"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      {block?.attributes?.providerNameSlug === "youtube" ? (
        <Youtube attributes={block?.attributes} />
      ) : (
        <Embed attributes={block?.attributes} />
      )}
    </Suspense>
  ),
  ["core/buttons"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Buttons key={block.id} attributes={block?.attributes}>
        <BlockRenderer blocks={block.innerBlocks} />
      </Buttons>
    </Suspense>
  ),
  ["core/button"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Button attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/html"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Html attributes={block?.attributes} originalContent={block?.originalContent} />
    </Suspense>
  ),
  ["core/freeform"]: (block) => (
    <div
      key={block?.id}
      className="jlt-blog-content jlt-classic-content"
      dangerouslySetInnerHTML={{ __html: block?.attributes?.page_content || "" }}
    />
  ),
  ["core/list-item"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <ListItem attributes={block?.attributes}>
        {Array.isArray(block?.innerBlocks) && block.innerBlocks.length ? (
          <BlockRenderer blocks={block.innerBlocks} />
        ) : null}
      </ListItem>
    </Suspense>
  ),
  ["core/list"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <List attributes={block?.attributes}>
        <BlockRenderer blocks={block.innerBlocks} />
      </List>
    </Suspense>
  ),
  ["core/code"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Code key={block.id} attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/cover"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Cover image={block.attributes.url}>
        <BlockRenderer blocks={block.innerBlocks} />
      </Cover>
    </Suspense>
  ),
  ["core/heading"]: (block) => <Heading id={block?.id} attributes={block?.attributes} />,
  ["core/paragraph"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Paragraph attributes={block?.attributes} />
    </Suspense>
  ),
  // ["core/group"]: (block) =>
  // ["core/block"]: (block) => {
  //     return <BlockRenderer  blocks={block.innerBlocks} />;
  // }
  ["core/image"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Image attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/separator"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Separator attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/spacer"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Spacer attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/table"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Table attributes={block?.attributes} />
    </Suspense>
  ),
};
